export default "__VITE_ASSET__BPGAuvOZ__"